import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ButtonLink from "../../components/Button";
import BanquetsMeta from '../../metaTags/BanquetsMeta';

import "../../style/gallery.scss";
import "../../style/title.scss";
import "../../components/Button/index.scss"
import "./index.scss";


import Banquet1 from "../../assets/images/banquet1.webp"
import Banquet2 from "../../assets/images/banquet2.webp"
import Banquet3 from "../../assets/images/banquet3.webp"
import Banquet4 from "../../assets/images/banquet4.webp"
import Banquet5 from "../../assets/images/banquet5.webp"


function Banquets(){
  const { t } = useTranslation();  
  const { lang } = useParams(); 
  
  const images = [Banquet1, Banquet2, Banquet3, Banquet4, Banquet5];
  const [loadedImages, setLoadedImages] = useState({}); 

  const handleImageLoad = (src) => {
    setLoadedImages((prev) => ({ ...prev, [src]: true })); 
  };

  return(
        <div className="banquets-wrapper">
          <BanquetsMeta />
          <div className='title'>
              <div className='text big'>{t('banquets')}</div>
              <div className='text desktop'>{t('banquets-title')}</div>
              <div className='text mobile'>{t('banquets-title')}</div>
          </div>
          <div className='description'>
            <p>
              {t('text-banquets-1')}
            </p>
            <br/>
            <p>
              {t('text-banquets-2')}
            </p>
            <br/>
            <p>
              {t('text-banquets-3')}
            </p>
            <br/>
            <p>
              {t('text-banquets-4')}
            </p>
          </div>
          <ButtonLink to={`/${lang}/reservation`} className="btn-menu btn-with-borders">
            <span>{t('application')}</span>
          </ButtonLink>
          <div className="gallery">
          <div className="layer layer-first">
            <div className="img1">
            {!loadedImages[Banquet1] && <div className="spinner"></div>}
                <img
                  src={Banquet1}
                  alt=""
                  onLoad={() => handleImageLoad(Banquet1)}
                  style={loadedImages[Banquet1] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="img2">
            {!loadedImages[Banquet2] && <div className="spinner"></div>}
                <img
                  src={Banquet2}
                  alt=""
                  onLoad={() => handleImageLoad(Banquet2)}
                  style={loadedImages[Banquet2] ? {} : { visibility: 'hidden' }}
                />
            </div>
          </div>
          <div className="layer layer-second">
            <div className="img1">
            {!loadedImages[Banquet3] && <div className="spinner"></div>}
                <img
                  src={Banquet3}
                  alt=""
                  onLoad={() => handleImageLoad(Banquet3)}
                  style={loadedImages[Banquet3] ? {} : { visibility: 'hidden' }}
                />
              </div> 
          </div>
          <div className="layer layer-third">
            <div className="img1">
            {!loadedImages[Banquet5] && <div className="spinner"></div>}
                <img
                  src={Banquet5}
                  alt=""
                  onLoad={() => handleImageLoad(Banquet5)}
                  style={loadedImages[Banquet5] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="img2">
            {!loadedImages[Banquet4] && <div className="spinner"></div>}
                <img
                  src={Banquet4}
                  alt=""
                  onLoad={() => handleImageLoad(Banquet4)}
                  style={loadedImages[Banquet4] ? {} : { visibility: 'hidden' }}
                />
            </div>
          </div>
          </div>
        </div>
    )
}

export default Banquets;